export class AuthModel{
    username: string;
    password: string;
}